import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Food(props: StickerArtProps) {
  return (
    <StickerFrame background="#fbbf24" {...props}>
      <path
        d="M32 23 C24 16 13 22 15 34 C17 46 26 52 32 49 C38 52 47 46 49 34 C51 22 40 16 32 23 Z"
        fill="#dc2626"
        stroke="#ffffff"
        strokeWidth="2.5"
      />
      <path d="M32 23 V15" stroke="#1f2937" strokeWidth="3" strokeLinecap="round" />
      <path d="M34 19 C35 13 41 11 45 12 C43 17 39 20 34 19 Z" fill="#16a34a" />
    </StickerFrame>
  );
}
